import {
    Checkbox,
    FormControlLabel,
    FormGroup,
    Grid,
    Icon,
    IconButton,
    InputAdornment,
    TextField,
    MenuItem
} from "@mui/material";
import {Box} from "@mui/system";
import {useEffect, useState} from "react";
import {useNavigate, useSearchParams} from "react-router-dom";
import {useQueryParam, useSetParam} from "../../shared/useQueryParam";

function Busca() {
    const [params, setParams] = useSearchParams();
    const expressaoIni = useQueryParam("expressao") || "";
    const tipoIni = useQueryParam("tipo") || "";
    const incluirArquivadosIni = useQueryParam("incluirArquivados") === "true";
    const [expressao, setExpressao] = useState(expressaoIni);
    const [tipo] = useState(tipoIni);
    const [incluirArquivados, setIncluirArquivados] =
        useState(incluirArquivadosIni);
    const setParam = useSetParam();
    const navigate = useNavigate();

    function handleSubmit(event) {
        event.preventDefault();
        navigate(`/?${setParam("expressao", expressao)}`);
    }

    function limpar() {
        setExpressao("");
        navigate(`/?${setParam("expressao", "")}`);
    }

    // eslint-disable-next-line
    useEffect(() => navigate(`/?${setParam("tipo", tipo)}`), [tipo]);

    useEffect(
        () => navigate(`/?${setParam("incluirArquivados", incluirArquivados)}`),
        // eslint-disable-next-line
        [incluirArquivados]
    );

    return (
        <Box marginBottom={2}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                    <form onSubmit={handleSubmit}>
                        <TextField
                            value={expressao}
                            onChange={(e) => setExpressao(e.target.value)}
                            fullWidth
                            size="small"
                            placeholder="Pesquisar dados da ocorrencia"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <IconButton edge="start" type="submit">
                                            <Icon>search</Icon>
                                        </IconButton>
                                    </InputAdornment>
                                ),
                                endAdornment:
                                    expressao || expressaoIni ? (
                                        <InputAdornment position="end">
                                            <IconButton
                                                edge="end"
                                                onClick={limpar}
                                            >
                                                <Icon>close</Icon>
                                            </IconButton>
                                        </InputAdornment>
                                    ) : undefined
                            }}
                        />
                    </form>
                </Grid>
                <Grid item xs={12} md={3}>
                    <TextField
                        select
                        fullWidth
                        size="small"
                        label="Tipo de envio"
                        value={params.get("destinoEntrega") || ""}
                        onChange={(event) => {
                            const novos = new URLSearchParams(params);
                            if (event.target.value)
                                novos.set("destinoEntrega", event.target.value);
                            else novos.delete("destinoEntrega");
                            novos.set("page", "0");
                            setParams(novos);
                        }}
                    >
                        <MenuItem value="">Todos os envios</MenuItem>
                        <MenuItem value="ESFINGE_DIRETO">
                            e-Sfinge direto
                        </MenuItem>
                        <MenuItem value="FORNECEDOR">Fornecedor</MenuItem>
                        <MenuItem value="SEM_DESTINO">
                            Sem destino definido
                        </MenuItem>
                    </TextField>
                </Grid>
                <Grid item xs={12} md={3}>
                    <FormGroup sx={{color: "text.secondary"}}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={incluirArquivados}
                                    onChange={(e) =>
                                        setIncluirArquivados(e.target.checked)
                                    }
                                />
                            }
                            label="Incluir arquivados"
                        />
                    </FormGroup>
                </Grid>
            </Grid>
        </Box>
    );
}

export default Busca;
